export default "__VITE_ASSET__b686ba35__"